import defaultVariables from '@/i18n/defaultVariables.json';
import { LANGUAGE_CODES } from '@/i18n/supportedLanguages';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector'; // For auto detecting the user language: https://github.com/i18next/i18next-browser-languageDetector
import Backend from 'i18next-http-backend'; // For lazy loading for translations: https://github.com/i18next/i18next-http-backend
import { initReactI18next } from 'react-i18next'; // https://react.i18next.com/latest/using-with-hooks

// Create a version parameter to bust cache on new deployments
const getTranslationVersion = () => {
  // Use build timestamp or app version for cache busting
  // In production, this could be replaced with actual build version
  const buildTime = import.meta.env.VITE_RELEASE_TIME || Date.now();
  return buildTime.toString();
};

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    supportedLngs: LANGUAGE_CODES,
    // load: 'languageOnly', // <-- prevents en-US + en double-fetch
    backend: {
      loadPath: '/locales/{{lng}}.json',
      // Add cache busting parameter to force reload of translations on new builds
      queryStringParams: { v: getTranslationVersion() },
    },
    // ns: [''],
    // defaultNS: '',
    fallbackLng: ['en_US'],
    // Pluralization configuration
    pluralSeparator: '_',
    contextSeparator: '_',
    interpolation: {
      escapeValue: false, // React already escapes values
      defaultVariables,
    },
    // Enable debugging in development
    // debug: import.meta.env.DEV,
  });

export default i18n;
